import { useQuery, useMutation } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { fetchInvoices, fetchInvoiceImage } from "../api/invoices.api";

const useInvoices = () => {
  const [bearerToken, companyId] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken, state.companyId])
  );

  const { data, error, isLoading } = useQuery({
    queryKey: ["invoices"],
    queryFn: () => fetchInvoices(bearerToken as string, companyId as number),
    enabled: !!companyId,
  });
  const fetchInvoiceImageMutation = useMutation({
    mutationFn: (invoiceId: number) =>
      fetchInvoiceImage(bearerToken as string, companyId as number, invoiceId),
  });

  const downloadInvoiceImage = async (invoiceId: number) => {
    const imageBlob = await fetchInvoiceImageMutation.mutateAsync(invoiceId);

    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(imageBlob);

    // Create a temporary anchor element and trigger download
    const link = document.createElement("a");
    link.href = url;
    link.download = `sumion-${invoiceId}.png`;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return {
    invoiceData: data,
    invoiceError: error,
    isLoadingInvoices: isLoading,
    downloadInvoiceImage,
  };
};

export default useInvoices;
